'use client'

import styled from 'styled-components'

import {media} from '@/src/config/theme'

export const Wrapper = styled.div``

export const ShopList = styled.div`
  display: grid;

  gap: 34px;

  grid-template-columns: 1fr;

  @media ${media.md} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  & > * {
    transition: ease all 0.3s;

    &:hover {
      transform: scale(1.05);
    }
  }
`

export const Map = styled.div`
  padding: 34px 0;
  width: 100%;

  .popover-content {
    color: white;
  }
`
